<template>
  <div>
    <p
      v-if="name"
      :class="{ isRequired: isRequired }"
      class="optionLabel">
      {{ name[lang] }}
      <span v-if="isRequired && !isValid" class="requiredStkr notranslate">{{ locale.required }}</span>
    </p>

    <input
      v-model="selected"
      type="text"
      class="input"
    />
  </div>
</template>

<script>
export default {
  name: 'OptionInput',

  props: [
    'locale',
    'lang',
    'shopItemId',
    'shopResponsive',
    'uniqueId',
    'optionInfo',
    'isSubOption',
    'cartOptionData'
  ],
  computed: {
    isValid () {
      return !this.isRequired || this.selected.length > 0
    }
  },
  created () {
    this.name = this.optionInfo.name
    this.isRequired = this.optionInfo.isRequired
    this.selected = this.optionInfo.selected || ''
    if (this.cartOptionData) {
      const cartOptionItem = this.cartOptionData.optionItems &&
        this.cartOptionData.optionItems[0]

      this.selected = (cartOptionItem && cartOptionItem.value) || ''
    }
  },
  watch: {
    selected (selected) {
      const data = {
        ...this.optionInfo.id && {
          id: this.optionInfo.id
        },
        ...this.optionInfo.optionId && {
          optionId: this.optionInfo.optionId
        },
        name: this.optionInfo.name,
        uniqueId: this.uniqueId,
        isValid: this.isValid,
        optionItems: selected
          ? [
              {
                value: selected
              }
            ]
          : []
      }

      this.$store.commit('shop/setDetailOptions', [data])
    }
  },
  data () {
    return {
      name: {},
      isRequired: false,
      selected: ''
    }
  },
}
</script>

<style lang="scss" scoped>
.input {
  border-radius: 4px;
}
</style>